import { getSessionValue } from '../default/getSessionValue'

const SESSION_ID = 'tdMainFunnel'

/**
 * The everflow transaction id for this visit.
 *
 * @returns {{ trid?: string }}
 */
export function getTrackingIds() {
  try {
    const trid =
      new URLSearchParams(window.location.search).get('trid') ||
      getSessionValue(SESSION_ID, 'trid') ||
      ''

    return trid ? { trid: String(trid) } : {}
  } catch {
    return {}
  }
}
